/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import * as _ from 'lodash';
import { DataStoreService } from '../../../../../src/app/core/services/datastore.service';
import { TerminalStatus } from '../../../core/model/terminal-status.model';
import { TerminalSummary } from '../../../core/model/terminal-summary.model';
import { TrainData } from '../../../core/model/train-data.model';
import { LmsTerminalStatusSubmenuService } from '../../../core/services/lms-terminal-status-submenu.service';
import { UserService } from '../../../core/services/user.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { Tab } from './../../../core/model/tab.model';
import { ConfigService } from './../../../core/services/config.service';
import { LmsTabsDragDropService } from './../../../core/services/lms-tabs-drag-drop.service';



@Component({
  selector: 'lms-terminal-view-status',
  templateUrl: './lms-terminal-view-status.component.html',
  styleUrls: ['./lms-terminal-view-status.component.scss']
})
export class LmsTerminalViewStatusComponent implements OnInit, OnDestroy, AfterViewInit {
  imagesPath;
  heightArray: Array<string>;
  @Input() tab: Tab;
  @Input() collpase: Boolean;
  @Input() direction: string;
  @Input() header: string;
  @Input() statusList: Boolean;
  @Input() allData: TerminalStatus;
  @Input() fullPageModeHeight: number;

  @Input() boundTrains: Array<TrainData>;
  @Output() showLocoMenu: EventEmitter<Map<string, any>> = new EventEmitter<Map<string, any>>();
  @Output() heightCalculate: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() toggleBound = new EventEmitter();
  @Input() terminalSummary: TerminalSummary;

  dataWidth: number;
  dataHeight: number;
  displayedItems = [];
  page = 0;
  numOfVisible: number;
  locoWidth = 218;
  getNumberOfItemVisible = 0;
  startIndex: number;
  endIndex: number;
  totalPage: number;
  viewportHeight: number;
  width: number;
  itemsInEachRow: number;
  scrollHeightArray = [];
  numOfRows: number;
  scrollheight: number;
  scrollTop: number;


  constructor(private configService: ConfigService,
    private lmsTabsDragDropService: LmsTabsDragDropService,
    private dataStoreService: DataStoreService,
    renderer: Renderer2,
    private lmsTerminalStatusSubmenuService: LmsTerminalStatusSubmenuService,
    public user: UserService) {
    this.imagesPath = this.configService.getConfigData().images;
    this.heightArray = [];
    renderer.listen('window', 'resize', () => {
      this.calcuateDataWidth(true);
    });
  }

  ngOnInit() {
    this.initializeData();
    
  }

  calcuateDataWidth(fromResize?: Boolean) {
    setTimeout(() => {
      if (document.getElementsByClassName('train-drag-content') && document.getElementsByClassName('train-drag-content').length > 0) {
        this.dataWidth = document.getElementsByClassName('train-drag-content')[0].clientWidth;
        this.dataHeight = document.getElementsByClassName('train-drag-content')[0].clientHeight;
        const locoHeight = this.getSectionHeight();
        this.getNumberOfItemVisible = Math.floor(this.dataWidth / this.locoWidth) * Math.floor(this.dataHeight / locoHeight);
        this.totalPage = Math.ceil(this.boundTrains[0].locoDetails.length / this.getNumberOfItemVisible);
        if (!fromResize) {
          let index = _.findIndex(this.boundTrains[0].locoDetails, ['clicked', true]);
          if (index < -1 && this.allData.isLocated) {
            index = _.findIndex(this.boundTrains[0].locoDetails, ['isLocated', true]);
          }
          if (index > -1) {
            this.page = Math.floor(index / this.getNumberOfItemVisible);
          }
        } else {
          this.page = Math.floor(this.startIndex / this.getNumberOfItemVisible);
        }
        this.adjustDisplayArray();
      }
    }, 100);
  }

  getSectionHeight() {
    if (this.lmsTerminalStatusSubmenuService && this.lmsTerminalStatusSubmenuService.terminalStatusList) {
      for (let i = 0; i < this.lmsTerminalStatusSubmenuService.terminalStatusList.length; i++) {
        const item = this.lmsTerminalStatusSubmenuService.terminalStatusList[i];
        if (this.header === item.display) {
          return item.height;
        }
      }
    }
  }

  onPrevNav() {
    this.page--;
    if (this.page < 0) {
      this.page = 0;
    }
    this.adjustDisplayArray();
  }

  onNextNav() {
    this.page++;
    if (this.page >= (this.totalPage - 1)) {
      this.page = this.totalPage - 1;
    }
    this.adjustDisplayArray();
  }

  adjustDisplayArray() {
    this.startIndex = (this.page * this.getNumberOfItemVisible);
    this.endIndex = ((this.page + 1) * this.getNumberOfItemVisible);
    if (this.endIndex > this.boundTrains[0].locoDetails.length) {
      this.endIndex = this.boundTrains[0].locoDetails.length;
    }
    this.displayedItems = this.boundTrains[0].locoDetails && this.boundTrains[0].locoDetails.length > 0 ? this.boundTrains[0].locoDetails.slice(this.startIndex, this.endIndex) : [];
  }


  ngAfterViewInit() {
    this.calcuateDataWidth();
  }

  initializeData() {
    if (this.header === 'IN READY FIELD') {
      this.boundTrains[0].locoDetails = this.allData.terminalStatusLocos.inReadyTrackList;
    } else if (this.header === 'ON TERMINAL') {
      this.boundTrains[0].locoDetails = this.allData.terminalStatusLocos.onTerminalList;
    } else if (this.header === 'AT SERVICE CENTER') {
      this.boundTrains[0].locoDetails = this.allData.terminalStatusLocos.atServiceCentreList;
    } else if (this.header === 'ON PIT') {
      this.boundTrains[0].locoDetails = this.allData.terminalStatusLocos.onPitList;
    } else if (this.header === 'DUE OUT SHOP') {
      this.locoWidth = 168;
      this.boundTrains[0].locoDetails = this.allData.terminalStatusLocos.inShopList;
    } else if (this.header === 'STORED') {
      this.locoWidth = 168;
      this.boundTrains[0].locoDetails = this.allData.terminalStatusLocos.storedAtTerminalList;
    }
    if (this.allData && this.allData.terminalStatusLocos && this.allData.terminalStatusLocos.terminalSummary) {
      this.terminalSummary = this.allData.terminalStatusLocos.terminalSummary;
    }
  }


  private isContextMenuAvailable(locomotive: LocoDetail) {
    if (locomotive && locomotive.locomotiveIdentifier) {
      if (locomotive.locomotiveIdentifier.toUpperCase() === 'ZZZZZZZZZZZZZZ' || locomotive.locomotiveIdentifier.trim() === '') {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }


  public showLocomotiveContextMenu(loco: LocoDetail, train: TrainData, index: string, header: string) {
    if (this.isContextMenuAvailable(loco)) {
      const locoMenu = new Map<string, any>();
      locoMenu.set('locoData', loco);
      locoMenu.set('trainId', train && train.trainIdentifier ? 'trainId' + train.trainIdentifier : 'trainId');
      locoMenu.set('index', index);
      locoMenu.set('header', header);
      this.showLocoMenu.emit(locoMenu);
    }
  }

  resetStatusListOpenState() {
    this.tab.openState = { headerName: '', status: null, activeStatus: false, collpase: null, singleClick: true };
    const tabData = {
      id: this.tab.id,
      subType: this.tab.subType,
      data: {}
    };
    tabData.data[this.tab.subType] = this.allData;
    this.dataStoreService.putValue(this.tab, tabData);
    //this.lmsModuleService.updateSelectedTab(this.tab);

    setTimeout(() => {
      // to enable plan button header
      this.lmsTabsDragDropService.updateInteractiveLocoTrains();
    }, 100);
    this.heightCalculate.emit(true);
  }

  checkForblankLocoIdentifier(loco: LocoDetail) {
    return loco.locomotiveIdentifier.trim() === '';
  }

  onLocoClick(loco: LocoDetail, event) {
    event.stopPropagation();
    if (loco.inPendingList || loco.locomotiveIdentifier.toLowerCase() === 'zzzzzzzzzzzzzz' || loco.locomotiveIdentifier.trim() === '') {
      return false;
    }

    loco.order = ++this.resetAllClickOnTrainLocos(true, false, false, false).locoCounter;
    loco.clicked = !loco.clicked;

    if (loco.clicked) {
      if (this.resetAllClickOnTrainLocos(false, false, false, false).trainCounter === 1) {
        loco.order = ++this.resetAllClickOnTrainLocos(false, false, false, false).locoCounter;
      } else {
        loco.order = ++this.resetAllClickOnTrainLocos(true, false, false, false).locoCounter;
      }
    } else {
      loco.order = 0;
    }

    this.lmsTabsDragDropService.updateInteractiveLocoTrains(loco, loco.clicked ? true : false);
  }


  private resetAllClickOnTrainLocos(setTrainStatus: Boolean, trainStatus: Boolean, setLocoStatus: Boolean, locoStatus: Boolean) {
    const inBoundTrains = this.allData.terminalStatusIO.inBoundTrains;
    const outBoundTrains = this.allData.terminalStatusIO.outBoundTrains;
    const terminalList = this.allData.terminalStatusLocos;
    const totalTerminalListLocos = [terminalList.onTerminalList,
    terminalList.atServiceCentreList,
    terminalList.onPitList,
    terminalList.inShopList,
    terminalList.inReadyTrackList,
    terminalList.storedAtTerminalList,
    terminalList.yardAndLocalList
    ];

    const inBoundTrainsLength = inBoundTrains.length;
    const outBoundTrainsLength = outBoundTrains.length;
    let trainCounter = 0;
    let locoCounter = 0;
    // for inBoundTrains
    for (let i = 0; i < inBoundTrainsLength; i++) {
      if (setTrainStatus) {
        this.setTrainClickedStatus(inBoundTrains[i], trainStatus, locoStatus);
      } else {
        const inBoundMaxOrder = this.getTrainCounter(inBoundTrains[i]);
        trainCounter = inBoundMaxOrder > trainCounter ? inBoundMaxOrder : trainCounter;
      }

      const locos = inBoundTrains[i].locoDetails;
      if (setLocoStatus) {
        this.setTrainLocosClickedStatus(locos, locoStatus);
      } else {
        const inLocoMaxOrder = this.getLocoCounter(locos);
        locoCounter = inLocoMaxOrder > locoCounter ? inLocoMaxOrder : locoCounter;
      }

    }

    // for outboundTrains
    for (let i = 0; i < outBoundTrainsLength; i++) {
      if (setTrainStatus) {
        this.setTrainClickedStatus(outBoundTrains[i], trainStatus, locoStatus);
      } else {
        const outBoundMaxOrder = this.getTrainCounter(outBoundTrains[i]);
        trainCounter = outBoundMaxOrder > trainCounter ? outBoundMaxOrder : trainCounter;
      }

      const locos = outBoundTrains[i].locoDetails;
      if (setLocoStatus) {
        this.setTrainLocosClickedStatus(locos, locoStatus);
      } else {
        const outLocoMaxOrder = this.getLocoCounter(locos);
        locoCounter = outLocoMaxOrder > locoCounter ? outLocoMaxOrder : locoCounter;
      }
    }

    if (setLocoStatus) {
      // in terminal List only Locos Exist
      for (let k = 0; k < totalTerminalListLocos.length; k++) {
        if (!_.isEmpty(totalTerminalListLocos[k])) {
          this.setTrainLocosClickedStatus(totalTerminalListLocos[k], locoStatus);
        }
      }

    } else {
      for (let k = 0; k < totalTerminalListLocos.length; k++) {
        if (!_.isEmpty(totalTerminalListLocos[k])) {
          const terminalListMaxOrder = this.getLocoCounter(totalTerminalListLocos[k]);
          locoCounter = terminalListMaxOrder > locoCounter ? terminalListMaxOrder : locoCounter;
        }
      }
    }

    return { trainCounter: trainCounter, locoCounter: locoCounter };
  }


  private getLocoCounter(locos: Array<LocoDetail>) {
    let locoCount = 0;
    const locosLength = locos && locos.length ? locos.length : 0;
    for (let k = 0; k < locosLength; k++) {
      if (!locos[k].inPendingList) {
        locoCount = locos[k].order > locoCount ? locos[k].order : locoCount;
      }
    }
    return locoCount;
  }

  private getTrainCounter(train: TrainData) {
    return !train.inPendingList ? train.order : 0;
  }

  private setTrainClickedStatus(train: TrainData, trainStatus: Boolean, locoStatus: Boolean) {
    train.clicked = trainStatus;
    train.order = 0;
  }


  private setTrainLocosClickedStatus(locos: Array<LocoDetail>, status: Boolean) {
    const locosLength = locos.length;
    for (let k = 0; k < locosLength; k++) {
      locos[k].clicked = status;
      locos[k].order = 0;

    }
  }

  ngOnDestroy() {

  }

  trackByTrainIdentifier(item) {
    return item.trainIdentifier;
  }

  trackByLocomotiveIdentifier(item) {
    return item.locomotiveIdentifier;
  }

}
